import React from "react";
import "../stylesheet/prescription.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { BiSolidPlusCircle } from "react-icons/bi";
import { FiEye } from "react-icons/fi";
import Cards from "../components/prescription/Cards";
import Activities from "../components/prescription/Activities";
import activitiesData from "../components/prescription/Activities";
import { getAllPriscriptions } from "../Utils/localStore";
import Topnav from "../components/others/Topnav";

const Prescription = ({ notify }) => {
  const navigate = useNavigate();
  const [allPatients, setAllPatients] = useState([]);

  const getLocalData = async () => {
    let response;
    try {
      await getAllPriscriptions().then((resp) => (response = resp));
      return setAllPatients(response);
    } catch (error) {
      notify.error(error, { position: notify.POSITION.TOP_CENTER });
      throw new Error(error);
    }
  };
  useEffect(() => {
    getLocalData();
    return console.log("Tried to fetch data");
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleNewPatient = () => {
    localStorage.setItem("patientEditMode", false);
    navigate("/patients/new-patient");
  };
  const handlePatientReport = () => {
    navigate("/patients/patient-report");
  };
  let countActive = allPatients.filter(
    (item) => item.patient?.status === "Active"
  ).length;
  let countInactive = allPatients.filter(
    (item) => item.patient?.status === "InActive"
  ).length;
  const patients = [
    {
      percent: null,
      value: allPatients.length || 0,
      type: "All Prescriptions",
      src: "all-prescriptions",
      data: [0, 20, 5, 35, 25, 45],
    },
    {
      percent: null,
      value: countActive || 0,
      type: "Active Prescriptions",
      src: "all-prescriptions",
      data: [0, 18, 10, 35, 15, 50, 25],
    },
    {
      percent: null,
      value: countInactive || 0,
      type: "Inactive Prescriptions",
      src: "all-prescriptions",
      data: [0, 20, 5, 35, 25, 45],
    },
  ];
  return (
    <div className="prescription_body">
      <Topnav />
      <div className="prescription">
        <div ref={dropdownRef} className="drop">
          <div className="flex justify-end w-full">
            <button onClick={toggleDropdown}>
              Prescriptions manager
              <span>{isOpen ? "▲" : "▼"}</span>
            </button>
            {isOpen && (
              <>
                <div className="top-button_dropdown w-[231px] bg-white z-10 absolute rounded-md border-gray-400/20 border-[2px] py-2">
                  <div className="p-3 hover:bg-slate-200 cursor-pointer">
                    <Link to="/prescription/new_prescription">
                      <div className="flex justify-center items-center">
                        <BiSolidPlusCircle />
                        <p className="ml-2">Add new prescription</p>
                      </div>
                    </Link>
                  </div>
                  <div className="p-3 hover:bg-slate-200 cursor-pointer">
                    <Link to="/prescription/all_prescription">
                      <div className="flex justify-center items-center">
                        <FiEye />
                        <p className="ml-2">View all prescriptions</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <Cards value={allPatients} eventSourced={patients} />

        <div className="view_button">
          <button>View custom report</button>
        </div>

        <div className="recent">
          <Activities data={activitiesData} notify={notify} />
        </div>
      </div>
    </div>
  );
};

export default Prescription;
